/**
 * Provider-neutral AI interface. The real provider is added later; for the MVP a
 * mock returns clearly-labelled sample suggestions.
 *
 * Rules baked into the type contract's intent:
 *  - AI ASSISTS the producer; it never reaches the presenter without approval.
 *  - Keys stay server-side. This interface is implemented on the SERVER only.
 *  - Output is always labelled and never presented as verified fact.
 */
import { z } from 'zod';
export const AiSuggestionKindSchema = z.enum([
    'followUpQuestion',
    'hotFact',
    'entity',
    'pronunciation',
    'timingWarning',
    'rewrite',
    'shorten',
]);
export const AiSuggestionSchema = z.object({
    id: z.string(),
    kind: AiSuggestionKindSchema,
    text: z.string(),
    /** Always true for the MVP mock. Reminds the UI to label it and require approval. */
    generated: z.literal(true),
    /** May require human verification (e.g. a claimed fact). */
    needsVerification: z.boolean().default(false),
});
//# sourceMappingURL=ai.js.map